import { Controller } from 'stimulus'

// Flashes a faint yellow background on activity rows that arrive live (Turbo
// prepends), then fades it out, so the creator can see something just landed.
// Rows already present on load (backfill) and rows merely swapped by the
// "thanked" toggle (a replace that reuses the same id) are left untouched.
export default class LiveActivityFeed extends Controller {
  connect() {
    this.seen = new Set()
    for (const child of this.element.children) {
      if (child.id) this.seen.add(child.id)
    }

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE || !node.id) continue
          if (this.seen.has(node.id)) continue // replaced row, not a new one
          this.seen.add(node.id)
          this.flash(node)
        }
      }
    })
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  flash(element) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    element.animate(
      [
        { backgroundColor: '#fef9c3' },
        { backgroundColor: '#fef9c3', offset: 0.25 },
        { backgroundColor: 'transparent' }
      ],
      { duration: 1800, easing: 'ease-out' }
    )
  }
}
